import { jwtDecode } from "jwt-decode";
import { getUserDataFromLocalStorage } from ".";

type JWTPayload = { exp: number; user: { id: string } };

export const checkIsTokenExpired = (passedToken?: string, safetyMarginSeconds = 180): boolean => {
  const userData = getUserDataFromLocalStorage();
  const token = passedToken || userData?.token || "";

  try {
    const { exp } = jwtDecode<JWTPayload>(token);
    if (!exp) return true;

    const now = Date.now() / 1000; // seconds
    return now >= exp - safetyMarginSeconds;
  } catch {
    return true;
  }
};

export const checkTokenSimilarity = (tokenA: string, tokenB: string): boolean => {
  const decodedTokenA = jwtDecode<JWTPayload>(tokenA);
  const decodedTokenB = jwtDecode<JWTPayload>(tokenB);

  return decodedTokenA?.user?.id == decodedTokenB?.user?.id;
};
